<template>
  <div :class="menuClass + ' custom-container'">
    <div v-if="loader" class="loading-layout">
      <v-progress-circular indeterminate color="primary"></v-progress-circular>
    </div>

    <div v-else class="profil page-wrapp">
      <v-row class="justify-center">
        <v-col
          :cols="!$vuetify.breakpoint.smAndDown ? 6 : 12"
          :class="
            !$vuetify.breakpoint.smAndDown ? 'justify-content-center' : ''
          "
        >
          <v-row class="align-center">
            <v-col v-on:click="goToLink('#/profil')" cols="1">
              <v-btn elevation="2" icon
                ><v-icon>mdi-chevron-left</v-icon></v-btn
              >
            </v-col>
            <v-col cols="11">
              <v-card-title>Kontaktinformasjon</v-card-title>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <template v-if="accounts && accounts.length > 1">
        <v-row class="justify-center">
          <v-col
            :cols="!$vuetify.breakpoint.smAndDown ? 7 : 12"
            :class="
              !$vuetify.breakpoint.smAndDown ? 'justify-content-center' : ''
            "
          >
            <v-row class="align-center">
              <v-col class="pb-0 mb-3">
                <v-select
                  v-model="selectAccount"
                  :items="selectItems"
                  item-text="label"
                  item-value="value"
                  label="Dine kontoer"
                  outlined
                  v-on:change="changeAccount"
                  hide-details
                ></v-select>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </template>
      <template v-else> </template>
      <v-row class="justify-center">
        <v-col
          :cols="!$vuetify.breakpoint.smAndDown ? 7 : 12"
          :class="
            !$vuetify.breakpoint.smAndDown ? 'justify-content-center' : ''
          "
        >
          <v-card
            class="contact mt-0 pt-8 pb-8 mb-5 pl-8 pr-8"
            v-for="item in selectedAccount"
            v-bind:key="item.Guid"
          >
            <div v-if="!editEnabled(item.Guid)">
              <v-row class="pt-0 mt-0">
                <v-col class="text-left text--secondary">Navn på konto</v-col>
              </v-row>
              <v-row class="pt-0 mt-1">
                <v-col class="text-left pt-0 mt-0"
                  ><v-card-title
                    class="pl-0 ml-0 pr-0 mr-0 mt-0 pt-0 mb-0 pb-0"
                    >{{ item.Name || "Konto" }}</v-card-title
                  ></v-col
                >
              </v-row>
              <v-row class="pt-0 mt-0">
                <v-col class="text-left text--secondary">Mobile number</v-col>
              </v-row>
              <v-row class="pt-0 mt-1">
                <v-col class="text-left pt-0 mt-0"
                  ><v-card-title
                    class="pl-0 ml-0 pr-0 mr-0 mt-0 pt-0 mb-0 pb-0"
                    >{{ item.mobile }}</v-card-title
                  ></v-col
                >
              </v-row>
              <v-row class="pt-0 mt-0">
                <v-col class="text-left text--secondary">Epost</v-col>
              </v-row>
              <v-row class="pt-0 mt-1">
                <v-col class="text-left pt-0 mt-0"
                  ><v-card-title
                    class="pl-0 ml-0 pr-0 mr-0 mt-0 pt-0 mb-0 pb-0"
                    >{{ item.email }}</v-card-title
                  ></v-col
                >
              </v-row>
              <v-row class="pt-0 mt-5">
                <v-col class="text-left text--secondary">Postadresse</v-col>
              </v-row>
              <v-row class="pt-0 mt-1">
                <v-col class="text-left pt-0 mt-0 pb-0 mb-0">
                  <div>
                    <div>
                      <v-card-title
                        class="pl-0 ml-0 pr-0 mr-0 mt-0 pt-0 mb-0 pb-0"
                        >{{ item.address.StreetName }}
                        {{ item.address.BuildingNumber }}</v-card-title
                      >
                    </div>
                    <div>
                      <v-card-title
                        class="pl-0 ml-0 pr-0 mr-0 mt-0 pt-0 mb-0 pb-0"
                        >{{ item.address.PostCode }}
                        {{
                          (item.address.CityName
                            ? item.address.CityName
                            : ""
                          ).toUpperCase()
                        }}</v-card-title
                      >
                    </div>
                  </div>
                </v-col>
              </v-row>
            </div>

            <div v-else>
              <v-row class="align-center mb-3">
                <v-col class="pt-0 mt-0 pb-0 mb-0" cols="1">
                  <v-icon>mdi-account</v-icon>
                </v-col>
                <v-col class="pt-0 mt-0 pb-0 mb-0" cols="11">
                  <v-text-field
                    v-model="selectedAccountEdit.accountName"
                    label="Konto"
                    hide-details
                  ></v-text-field>
                </v-col>
              </v-row>

              <v-row class="align-center mb-3">
                <v-col class="pt-0 mt-0 pb-0 mb-0" cols="1">
                  <v-icon>mdi-email</v-icon>
                </v-col>
                <v-col class="pt-0 mt-0 pb-0 mb-0" cols="11">
                  <v-text-field
                    v-model="selectedAccountEdit.firstEmail"
                    label="Email"
                    hide-details
                  ></v-text-field>
                </v-col>
              </v-row>

              <v-row class="align-center mb-3">
                <v-col class="pt-0 mt-0 pb-0 mb-0" cols="1">
                  <v-icon>mdi-cellphone-iphone</v-icon>
                </v-col>
                <v-col class="pt-0 mt-0 pb-0 mb-0" cols="11">
                  <v-text-field
                    v-model="selectedAccountEdit.firstMobile"
                    label="Mobile"
                    hide-details
                  ></v-text-field>
                </v-col>
              </v-row>

              <div class="mt-8">
                <v-row class="align-center mb-3">
                  <v-col class="pt-0 mt-0 pb-0 mb-0" cols="1">
                    <v-icon>mdi-map-marker</v-icon>
                  </v-col>
                  <v-col class="pt-0 mt-0 pb-0 mb-0" cols="11">
                    <v-text-field
                      v-model="selectedAccountEdit.firstAddress.StreetName"
                      label="Gatenavn"
                      hide-details
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row class="align-center mb-3">
                  <v-col class="pt-0 mt-0 pb-0 mb-0" cols="1">
                    <v-icon>mdi-map-marker</v-icon>
                  </v-col>
                  <v-col class="pt-0 mt-0 pb-0 mb-0" cols="11">
                    <v-text-field
                      v-model="selectedAccountEdit.firstAddress.BuildingNumber"
                      label="Husnummer"
                      hide-details
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row class="align-center mb-3">
                  <v-col class="pt-0 mt-0 pb-0 mb-0" cols="1">
                    <v-icon>mdi-map-marker</v-icon>
                  </v-col>
                  <v-col class="pt-0 mt-0 pb-0 mb-0" cols="11">
                    <v-text-field
                      v-model="selectedAccountEdit.firstAddress.PostCode"
                      label="Postnummer"
                      hide-details
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row class="align-center">
                  <v-col class="pt-0 mt-0 pb-0 mb-0" cols="1">
                    <v-icon>mdi-map-marker</v-icon>
                  </v-col>
                  <v-col class="pt-0 mt-0 pb-0 mb-0" cols="11">
                    <v-text-field
                      v-model="selectedAccountEdit.firstAddress.CityName"
                      label="Sted"
                      hide-details
                    ></v-text-field>
                  </v-col>
                </v-row>
              </div>
            </div>

            <div v-if="!editEnabled(item.Guid)">
              <div class="d-flex justify-end">
                <v-icon
                  v-if="!editEnabled(item.Guid)"
                  @click="editInfo(item.Guid, true)"
                  class="mr-5"
                  >mdi-pencil-outline</v-icon
                >
              </div>
            </div>
            <div v-else>
              <div class="d-flex justify-end mt-8">
                <button
                  type="button"
                  @click="save(item.Guid)"
                  class="
                    ma-2
                    white--text
                    v-btn v-btn--is-elevated v-btn--has-bg
                    theme--light
                    v-size--default
                    primary
                  "
                >
                  <span class="v-btn__content"> LAGRE </span></button
                ><button
                  type="button"
                  @click="editInfo(item.Guid, false)"
                  class="
                    ma-2
                    v-btn v-btn--is-elevated v-btn--has-bg
                    theme--light
                    v-size--default
                  "
                >
                  <span class="v-btn__content"> AVBRYT </span>
                </button>
                <!-- <v-icon @click="editInfo(item.Guid, false)" class="mr-3"
                  >mdi-close</v-icon
                >
                <v-icon @click="save(item.Guid)"
                  >mdi-content-save-outline</v-icon
                > -->
              </div>
            </div>
          </v-card>
        </v-col>
      </v-row>
      <v-snackbar v-model="snackbar">
        {{ snackbarText }}

        <template v-slot:action="{ attrs }">
          <v-btn color="pink" text v-bind="attrs" v-on:click="snackbar = false">
            Lukke
          </v-btn>
        </template>
      </v-snackbar>
    </div>
  </div>
</template>

<script>
import { account, editAccount } from "../../api/common";

import "./Profil.scss";

export default {
  name: "ContactInformation",

  components: {},

  data() {
    return {
      loader: false,
      menuClass: "",
      selectAccount: "",
      selectItems: [],
      selectedAccount: [],
      accounts: [],
      openEdit: {},
      selectedAccountEdit: {
        firstEmail: "",
        firstMobile: "",
        firstAddress: {},
        accountName: "",
      },
      snackbar: false,
      snackbarText: "",
    };
  },

  async mounted() {
    await this.getDataFromApi();

    if (
      this.$router &&
      this.$router.currentRoute &&
      this.$router.currentRoute.params &&
      this.$router.currentRoute.params.guid
    ) {
      this.selectAccount = this.$router.currentRoute.params.guid;
      this.changeAccount();
    }

    if (localStorage.tenant === "9876543210517") {
      this.menuClass = "sokrates";
    } else if (localStorage.tenant === "7080010002488") {
      this.menuClass = "klark";
    } else {
      this.menuClass = "hks";
    }
  },

  methods: {
    async getDataFromApi() {
      this.loader = true;
      this.selectItems = [{ label: "Se alle", value: "" }];
      this.selectAccount = "";
      this.accounts = [];

      try {
        let tmpAccounts = await account();
        tmpAccounts = tmpAccounts.data.Accounts;

        tmpAccounts.forEach((item) => {
          this.selectItems.push({
            label: item.Name || "Konto",
            value: item.Guid,
          });
          this.openEdit[item.Guid] = false;

          this.accounts.push(this.decorateAccount(item));
        });

        this.changeAccount();
      } catch (err) {
        this.snackbar = true;
        this.snackbarText = "Feil ved innlasting av data ";
      }

      this.loader = false;
    },

    changeAccount() {
      if (this.selectAccount) {
        let tmp = this.accounts.filter(
          (item) => item.Guid == this.selectAccount
        );
        tmp = tmp && tmp.length > 0 ? [tmp[0]] : this.accounts;

        this.selectedAccount = [];
        this.selectedAccount = [...tmp];
      } else {
        this.selectedAccount = [];
        this.selectedAccount = [...this.accounts];
      }

      for (let key in this.openEdit) this.openEdit[key] = false;
    },

    goToLink(route) {
      let tmp = document.createElement("a");
      tmp.href = route;
      tmp.click();
    },

    uuidv4() {
      return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
        /[xy]/g,
        function (c) {
          var r = (Math.random() * 16) | 0,
            v = c == "x" ? r : (r & 0x3) | 0x8;
          return v.toString(16);
        }
      );
    },

    async save(guid) {
      try {
        let tmp = this.selectedAccount.filter((item) => item.Guid == guid)[0];
        if (tmp.Addresses && tmp.Addresses.length > 0) {
          tmp.Addresses[0] = this.selectedAccountEdit.firstAddress;
        } else {
          tmp.Addresses.push(this.selectedAccountEdit.firstAddress);
        }
        let firstEmail = tmp.Communication.filter(
          (com) => com.Channel == "Email"
        );
        if (firstEmail && firstEmail.length > 0) {
          firstEmail[0].Value = this.selectedAccountEdit.firstEmail;
        } else {
          tmp.Communication.push({
            Channel: "Email",
            Value: this.selectedAccountEdit.firstEmail,
            Description: "",
          });
        }
        let firstMobile = tmp.Communication.filter(
          (com) => com.Channel == "Mobile"
        );
        if (firstMobile && firstMobile.length > 0) {
          firstMobile[0].Value = this.selectedAccountEdit.firstMobile;
        } else {
          tmp.Communication.push({
            Channel: "Mobile",
            Value: this.selectedAccountEdit.firstMobile,
            Description: "",
          });
        }
        tmp.Name = this.selectedAccountEdit.accountName;

        let data = {
          RequestId: this.uuidv4(),
          Addresses: tmp.Addresses,
          Communication: tmp.Communication,
          Name: tmp.Name,
        };

        await editAccount(guid, data);
      } catch (err) {
        this.snackbar = true;
        this.snackbarText = "Feil data oppdater";
      }

      await this.getDataFromApi();
      this.$forceUpdate();
    },

    editInfo(guid, value) {
      let newOptions = Object.assign({}, this.openEdit);
      for (let key in newOptions) newOptions[key] = false;
      newOptions[guid] = value;
      this.openEdit = newOptions;

      let tmp = this.accounts.filter((item) => item.Guid == guid);
      tmp = tmp && tmp.length > 0 ? tmp[0] : false;
      this.selectedAccountEdit = {};

      if (value) {
        if (tmp) {
          this.selectedAccountEdit = Object.assign({}, tmp);
          this.selectedAccountEdit.firstEmail = "";
          this.selectedAccountEdit.firstMobile = "";
          this.selectedAccountEdit.firstAddress = {};
          if (tmp.Communication) {
            this.selectedAccountEdit.firstMobile = (tmp.Communication.filter(
              (com) => com.Channel == "Mobile"
            ) || [{ Value: "" }])[0].Value;
            this.selectedAccountEdit.firstEmail = (tmp.Communication.filter(
              (com) => com.Channel == "Email"
            ) || [{ Value: "" }])[0].Value;
          }
          if (tmp.Addresses && tmp.Addresses.length > 0) {
            this.selectedAccountEdit.firstAddress = Object.assign(
              {},
              tmp.Addresses[0]
            );
          }
          if (tmp.Name) {
            this.selectedAccountEdit.accountName = tmp.Name;
          }
        } else {
          this.selectedAccountEdit.firstEmail = "";
          this.selectedAccountEdit.firstMobile = "";
          this.selectedAccountEdit.firstAddress = {};
          this.selectedAccountEdit.accountName = "";
        }
      }
    },

    editEnabled(guid) {
      return this.openEdit[guid];
    },

    decorateAccount(item) {
      let decoratedAccount = Object.assign({}, item);
      decoratedAccount.mobile = (item.Communication.filter(
        (com) => com.Channel == "Mobile"
      ) || [{ Value: "" }])[0].Value;
      decoratedAccount.email = (item.Communication.filter(
        (com) => com.Channel == "Email"
      ) || [{ Value: "" }])[0].Value;
      decoratedAccount.address = (item.Addresses || [{}])[0];
      return decoratedAccount;
    },
  },
};
</script>
